export default __webpack_public_path__ + "static/media/epec.f9234ec2.png";